import React from 'react';

interface Props {
  fillColor?: string;
}

function RightChevronButton({ fillColor = 'black' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 25 24"
      fill="none">
      <path
        d="M9.05664 18L15.0566 12L9.05664 6"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default RightChevronButton;
